<div class="row justify-content-md-center no-gutters marL10">
  <app-loader-icon *ngIf="showLoader"></app-loader-icon>
  <div class="col-12">
    <div class="row no-gutters">
      <div class="col-12 whiteBg">
        <h5 class="sectionTitleBig"><b>Business Chemistry Resources</b></h5>
        <div *ngIf="showResourceCount">
          {{totalResources > 25 ? 25 : totalResources}} of 25 max resources
        
        </div>
        <div class="col text-right" *ngIf="!showOrderingSave">
          <button type="button" (click)="onReorderClick()" *ngIf="showReorder" class="clickBtn">Reorder</button>
          <button type="reset" (click)="addResourcePop()" *ngIf="showAddResources" [disabled]="totalResources>24" class="clickBtn marL20">Add Resource</button>
        </div>


        <div class="col text-right" *ngIf="showOrderingSave">

          <button type="reset" (click)="saveOrder()" class="clickBtn marL20">Save</button>
          <button type="reset" (click)="cancelOrder()" class="clickBtn marL20">Cancel</button>
        </div>

        <div class="row">
          <div class="col resourcesList">

            <ul cdkDropList (cdkDropListDropped)="onDrop($event)">
              <li *ngFor="let item of resourcesData; let i = index" cdkDrag [cdkDragDisabled]="!dragEnabled" [ngStyle]="{'cursor': dragEnabled ? 'ns-resize' : 'default'}">
                <span class="resourceTitle">{{item.Title}}</span>
                <div>
                  <div [innerHTML]="htmltag(item.Description)" class="resourceDescription"></div>
                  <strong *ngIf="item.Description && item.Description.length > 250">...</strong>
                </div>
                <!-- Bug 3943420 fix -->
                <div tabindex="-1" (focusout)="resetHoverIndex()">
                  <a class="resourceEdit" (click)="resourceEditDrop(i)">...</a>

                  <div class="resourceEidtDown" *ngIf="i == hoverIndex">
                    <a class="" (click)="viewResourcePop(i)"><i class="fa fa-eye"></i> View</a>
                    <a class="" *ngIf="showEdit" (click)="editResourcePop(i)"> <i class="fa fa-edit"></i>  Edit</a>
                    <a class="" *ngIf="showRemove" (click)="removeResourcePop(i)"><i class="fa fa-trash"></i>  Remove</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="" *ngIf="editPopUp">
          <div class="popupMaskScreen"></div>
          <div class="resourcesAddEditPop">
            <div class="resourcePopHeader">
              <p class="sectionTitleBig">{{popupTitle}}</p>
              <span class="closeResourcePop" (click)="coloseEditResourcePop()"><i class="fa fa-close"></i></span>
            </div>
            <div *ngIf="validateTitle" [style.color]="'red'">
              <span><i class="fa fa-warning"></i> Please fill in all the required fields</span>
            </div>
            <div class="row">
              <div class="col-12" [style.font-weight]="'bold'">Title</div>
              <div class="col-12"><input maxlength="75" [disabled]="editorDisable" [(ngModel)]="titleData" type="text" /></div>
            </div>
            <div class="row" *ngIf="isViewMode">
              <div class="col-12" [style.font-weight]="'bold'">Description</div>
              <div class="col-12" [innerHTML]="htmltag(editorData)"></div>
            </div>
            <div class="row" *ngIf="!isViewMode">
              <div class="col-12" [style.font-weight]="'bold'">Description</div>
              <div class="col-12">
                <app-rich-text-editor [editorData]="editorData" [Module]="resourceModule" (newItemEvent)="SaveData($event)"></app-rich-text-editor>
              </div>
            </div>

            <div class="row" *ngIf="!isViewMode">
              <div class="col-12" [style.font-weight]="'bold'">Note:</div>
              <div class="col-12"> Please follow the below format to hyperlink a text.</div>
              <div class="col-12">
                Example: To hyperlink "Business chemistry" text add
                <div>{{linkText}}</div>
              </div>
            </div>
            <div class="row" *ngIf="!viewModeOn">
              <div class="col-12 pull-right text-right">
                <button type="reset" (click)="saveEditor()" class="clickBtn marL20">Save</button>
                <button type="reset" (click)="coloseEditResourcePop()" class="clickBtn marL20">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
